import React from 'react';
import PropTypes from 'prop-types';
import Styling from '../../components/AuthStyling';
import styles from './index.module.scss';
import Button from '../../components/Button';

const tokenInvalid = ({ history }) => {
  const request = () => {
    history.push('/pwd-recover');
  };
  const cancel = () => {
    history.push('/login');
  };
  return (
    <Styling message="Request Invalid.">
      <div className={styles.successButtonRow}>
        <Button
          text="CANCEL"
          onClick={cancel}
          type="button"
          color="secondary"
          theme="light"
        />
        <Button text="REQUEST AGAIN" onClick={request} type="button" />
      </div>
    </Styling>
  );
};

tokenInvalid.propTypes = {
  history: PropTypes.object.isRequired,
};

export default tokenInvalid;
